
export const partnerData = [
    {
      image: require(`../assets/profileImages/Nptel.png`),
      title: `Nptel`,
      link: `https://nptel.ac.in/`,
    },
    {
      image: require(`../assets/profileImages/TicTac.png`),
      title: `TicTacLearn`,
      link: `https://tictaclearn.org/`,
    },
    // {
    //   image: require(`../assets/profileImages/Partham.png`),
    //   title: `Pratham`,
    //   link: `https://www.pratham.org/`,
    // },
    {
      image: require(`../assets/profileImages/EkStep.png`),
      title: `EkStep`,
      link: `https://ekstep.org/`,
    },
  ];


  export const useCaseData = [
    {
      content:
        `Chitralekha is an open-source platform designed to facilitate video annotation, transcription, and translation in diverse Indic languages.`,
    },
    {
      content:
        `It leverages machine learning models to provide accurate and efficient video transcription and translation services.`,
    },
    {
      content:
        `Chitralekha supports a wide range of features, including transcription, translation, voice-over generation, speaker tagging, subtitle upload to YouTube, and noise tagging.`,
    },
    {
      content:
        `Chitralekha simplifies the process of creating multilingual subtitles and voice-over translations, making content accessible and inclusive to a wider audience.`,
    },
    {
      content:
        `Chitralekha allows the identification and labeling of speakers in videos, enhancing organization and understanding of conversations or presentations.`,
    },
    {
      content:
        `Subtitles generated with Chitralekha can be directly uploaded to YouTube, ensuring seamless integration with the platform.`,
    },
    {
      content:
        `Transcriptions can be exported in a bilingual docx format, facilitating further translation or analysis.`,
    },
    {
      content:
        `Chitralekha supports the export of voice-overs in various formats, including mp4, mp3, wav, and flac.`,
    },
    {
      content:
        `The platform includes noise tagging functionality to handle and label audio disturbances during video editing.`,
    },
    {
      content:
        `Over 300 hours of lectures and video content have been transcribed and translated across 7 organizations, benefiting learners in 8 Indic languages.`,
    },
    {
      content:
        `NPTEL is in the process of translating approximately 36,000 hours of video lectures into multiple Indic languages using Chitralekha.`,
    },
  ];